<script setup lang="ts">
import { ref } from 'vue';
import { FilterOption, PlanFilter } from '@/application/smallBusiness/domain/SmallBusinessPlanFilters';
import SelectFilters from '@/application/smallBusiness/infrastructure/components/SelectFilters.vue';

interface EmitInterface {
  (event: 'update-values', value: Array<PlanFilter>): void
}

const emits = defineEmits<EmitInterface>();

const props = withDefaults(defineProps<{
  filters: Array<PlanFilter>;
  sizeWidth?: string;
}>(), {
  sizeWidth: 'w-full',
});

const localFilters = ref(props.filters.map(filter => ({
  ...filter,
  options: filter.options.map(option => ({ ...option }))
})) as Array<PlanFilter>);

const updateValues = (filterName: string, newData: Array<FilterOption>): void => {
  const index = localFilters.value.findIndex(filter => filter.name === filterName);
  localFilters.value[index].options = newData;
  emitChanges();
};

const emitChanges = (): void => {
  emits('update-values', localFilters.value);
};
</script>
<template>
  <div class="flex flex-col w-full space-y-4" :class="sizeWidth">
    <div v-for="filter in localFilters" :key="filter.name" class="flex flex-col" :class="sizeWidth">
      <div class="flex mb-1 font-semibold text-gray-700">
        {{ filter.name }}
      </div>
      <SelectFilters :filter-name="filter.name" :filters="filter.options" @update-values="newOptions => updateValues(filter.name, newOptions)" />
    </div>
  </div>
</template>
